import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cursos-lista',
  templateUrl: './cursos-lista.component.html',
  styleUrls: [],
})
export class CursosListaComponent implements OnInit {
  // componenteRef é usado para definir o id da barra de pesquisa, retornando uma
  // referencia de qual componente está chamando o componente "barra-busca"
  componenteRef = 'cursos';
  stringPesquisa: string;
  deslocamento = 0; // descolamento de página
  paginaAtual: number;
  totalPaginas: number;
  totalResultados: any;
  eixos: any[];
  ordecao: any;
  filtro: any;
  eixo: any;
  queryParamsSubscription: Subscription;
  realizouBusca = false;
  error = false;
  cursos: any;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursos: { itens, paginaAtual, totalPaginas, totalItens },
        eixos, // Para os filtros
        cursoError,
        eixosError,
      } = data;

      this.error = cursoError !== undefined || eixosError !== undefined ? true : false;

      if (!this.error) {
        this.cursos = itens;
        this.paginaAtual = paginaAtual;
        this.totalPaginas = totalPaginas;
        this.totalResultados = totalItens;
        this.eixos = [{ id: 0, nome: 'Todos os cursos' }, ...eixos];
      }
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/cursos'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }

  recebeuInput(input: string[]) {
    this.realizouBusca = true;
    [this.stringPesquisa, this.ordecao, this.eixo, this.filtro] = input;
    this.router.navigate(['/cursos'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: 1,
        eixo: this.eixo === 0 ? '' : this.eixo,
        filtro: this.filtro,
        ordenacao: this.ordecao,
        query: this.stringPesquisa,
      },
    });
  }
}
